import { Directive, ElementRef, Input, HostListener } from "@angular/core";
const padding = "000000";
//Krupa Shah : Create directive to allow user to enter numbers with decimal points
@Directive({
    selector: '[NumberWithDecimal]'
  })

  export class NumberWithDecimal
  {
    private el: any;
    private prefix: string;
    private decimal_separator:string;
    private thousands_separator:string; 

  constructor(private elementRef:ElementRef) { 
    this.el = this.elementRef.nativeElement;
    this.decimal_separator='.';
    this.thousands_separator = ',';
  }

  ngOnInit(){
    
    this.el.value = this.transform(this.el.value);

  }

  transform(value: string, fractionSize:number = 0) : string {

    if(fractionSize == 0)
      fractionSize = 2;// Display default currency with 2 decimal

      if(parseFloat(value) % 1 != 0)
      {
        fractionSize = 2;
      }

      let [ integer, fraction = ""] = (parseFloat(value).toString() || "").toString().split(".");
      
      fraction = fractionSize > 0
      ? this.decimal_separator + (fraction+padding).substring(0, fractionSize) : "";

      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousands_separator);
      if(isNaN(parseFloat(integer)))
      {
            integer = "0";
      }
     
      return integer + fraction;        
  }

  //Parse value
  parse(value: string, fractionSize: number = 2): string {
      let [ integer, fraction = "" ] = (value || "")                                                     
                                                    .split(this.decimal_separator);
  
      integer = integer.replace(new RegExp(this.thousands_separator, "g"), "");
  
      fraction = parseInt(fraction, 10) > 0 && fractionSize > 0
        ? this.decimal_separator + (fraction + padding).substring(0, fractionSize)
        : "";
     
      return integer + fraction;
    }

  //listen on focus 
  @HostListener("focus",["$event.target.value","$event"])
  onFocus(value,event) {
    this.el.value = this.parse(value); // opossite of transform
    if(event.which== 9)
    {
        return false;
    }
    this.el.select();
    
  }

  //listen on blur
  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
   
    this.el.value = this.transform(value);
  }


  //listen on change
  @HostListener('input', ['$event']) onInputChange(event) {    
         
  }

  //listen on key down event to check and return only if entered value is number only
  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent> event;
      if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
          // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        
      }
  }
  }
